/* global _TL_ */
import _ from 'underscore';
import $ from 'jquery';
import config from '@bingads-webui-component-legacy/config/index';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import popoverExtender from '@bingads-webui-component-legacy/extension/bootstrap/popover';
import { bingadsGridColumn } from '@bingads-webui-component-legacy/bingads-grid/shared/column';
import { appendLearnMoreLink } from '@bingads-webui-component-legacy/help/index';
import bidToolTipLowBid from '@bingads-webui-campaign-legacy/budget/template/bidToolTipLowBid.pug';
import getTrafficEstimation from '@bingads-webui-campaign-legacy/budget/shared/getTrafficEstimation';
import bidEditorTemplate from '@bingads-webui-campaign-legacy/budget/template/bidEditor.pug';
import estimatedNumTemplate from '@bingads-webui-campaign-legacy/budget/template/estimatedNum.pug';
import { BaseAdGroupBidGrid } from '@bingads-webui-campaign-legacy/budget/view/base-bid-grid';
import PopupContentView from '@bingads-webui-campaign-legacy/budget/view/bid-suggestion-popup';
import { logBidView } from '@bingads-webui-campaign-legacy/budget/shared/log';
import { weekly2Monthly, weekly2MonthlyInt } from '@bingads-webui-campaign-legacy/budget/shared/weeklyToMonthly';
import decimal from '@bingads-webui-component-legacy/humanize/decimal';
import { adGroupTypeEnum } from '@bingads-webui-campaign-legacy/adgroup-create-advanced/util/adGroupTypeEnum';
import { setClarityTag } from '@bingads-webui-universal/clarity';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

const maxKeywordsToEstimate = 1000;
const bidRange = config.get('KeywordBidRange');
const bidHintKey = {
  NoClicks: 'TrafficEstimation_Hint_NoClicks',
  CriticalLowBid: 'TrafficEstimation_Hint_CriticalLowBid',
  NormalLowBid: 'TrafficEstimation_Hint_NormalLowBid',
  BidInvalid: 'Validation_BidFormatInvalid',
  BidExceedRange: 'Budget_TrafficEstimation_BidLimitationError',
  BidExceedMaxLength: 'Validation_Number_Max_Length',
  Other: 'GenericErrorMessage',
};
const bidStatus = {
  Error: 'error',
  Warning: 'warning',
  Suggesiton: 'suggestion',
  Good: 'ok',
};

function getBIValueByAdGroupType(item, value, campaignType) {
  if (item == null) {
    return null;
  }

  const isDSAMixedModeCampaignEnabled = _.result(config.get('Permissions'), 'IsDSAMixedModeCampaignEnabled', false);

  if (isDSAMixedModeCampaignEnabled && item.AdGroupType === adGroupTypeEnum.SearchDynamic && campaignType === 'search') {
    return null;
  }

  return value;
}

export class PerformanceGridView extends BaseAdGroupBidGrid {
  initialize({
    defaultBid,
    isBidEditable,
    activity,
    suggestionEnabled,
    activityLogger,
    campaignType,
    campaignId,
    currencyCode,
    newI18n,
  } = {}) {
    this.campaignType = campaignType;
    this.defaultBid = defaultBid;
    this.activity = activity;
    this.suggestionEnabled = suggestionEnabled;
    this.campaignId = campaignId;
    this.currencyCode = currencyCode;
    this.newI18n = newI18n;
    const lowBidBtnText = newI18n.getString(_TL_('Low Bid'));

    setClarityTag({ PerformanceGridView: 'true' });

    const gridColumns = [{
      name: 'adGroup',
      title: i18n.get('ColumnHeader_AdGroup'),
      property: (item) => item.Name,
      width: 130,
    }, bingadsGridColumn({
      i18n,
      name: 'bid',
      title: 'ColumnHeader_Bid',
      headClasses: ['grid-header-bidEditor'],
      helpId: 'pop_BA_CampaignCreate_Budget_Bid',
      template: (local) => {
        return bidEditorTemplate({
          i18n,
          bid: local.value.Bid,
          currency: config.get('AccountCurrencyCode'),
          bidHintKey: local.value && local.value.bidHintKey,
          bidStatus: local.value && local.value.bidStatus,
          suggestedBid: local.value && local.value.suggestedBid,
          isBidEditable,
          suggestionEnabled,
          lowBidBtnText,
          bidStatusENUM: bidStatus,
          adGroupType: local.value && local.value.AdGroupType,
        });
      },
      property: (item) => item,
    }), bingadsGridColumn({
      i18n,
      name: 'click',
      title: 'EstimatedClicks',
      helpId: 'pop_BA_CampaignCreate_Budget_EstClicks',
      template: (local) => {
        return estimatedNumTemplate({
          i18n,
          estimatedNum: local.value && getBIValueByAdGroupType(local.value, weekly2MonthlyInt(local.value && local.value.Clicks), campaignType),
          bidHintKey: local.value && local.value.bidHintKey,
          adGroupType: local.value && local.value.AdGroupType,
          bidStatus: local.value && local.value.bidStatus,
        });
      },
      property: (item) => item,
      type: 'number',
      format: 'integer',
    }), bingadsGridColumn({
      i18n,
      name: 'impression',
      title: 'EstimatedImpressions',
      helpId: 'pop_BA_CampaignCreate_Budget_EstImpressions',
      headClasses: ['grid-header-EstimatedImpressions'],
      template: (local) => {
        return estimatedNumTemplate({
          i18n,
          estimatedNum: local.value && getBIValueByAdGroupType(local.value, weekly2MonthlyInt(local.value && local.value.Impressions), campaignType),
          bidHintKey: local.value && local.value.bidHintKey,
          adGroupType: local.value && local.value.AdGroupType,
          bidStatus: local.value && local.value.bidStatus,
        });
      },
      property: (item) => item,
      type: 'number',
      format: 'integer',
    }), bingadsGridColumn({
      i18n,
      name: 'spend',
      title: 'EstimatedSpend',
      helpId: 'pop_BA_CampaignCreate_Budget_EstSpend',
      property: (item) => getBIValueByAdGroupType(item, weekly2Monthly(item.TotalCost), campaignType),
      type: 'number',
    })];

    super.initialize({
      defaultBid,
      gridColumns,
      gridName: 'performanceGrid',
      activityLogger,
      girdAriaLabel: this.options.newI18n.getString(_TL_('Performance Grid')),
    });
  }

  get events() {
    return {
      'click .low_bid': 'raiseBidPopup',
      'click .icon-info': 'toggleBidHint',
      'mouseover .icon-info': 'toggleBidHint',
    };
  }

  checkLimitaion() {
    const count = _.reduce(this.adGroups, ( memo, num ) => memo + _.size(num.Keywords), 0);

    return count <= maxKeywordsToEstimate;
  }

  getAdGroupsData() {
    return this.grid.gridView.get('dataSource').data;
  }

  bidUpdated(e, bid) {
    const newBidString = _.isUndefined(bid) ? e.target.value : bid;
    const selectedItem = this.grid.gridView.itemOfElement(e.target);

    if (this.activityLogger) {
      this.activityLogger.signal(`get new bid from: ${_.isUndefined(bid) ? 'user input' : 'other/suggestion'}, new value: ${newBidString}`);
    }

    selectedItem.Bid = newBidString;
    const validateResult = this.validateBid(selectedItem);

    if (validateResult.isValid) {
      // input bid value is valid
      this.fetchEstimate();
      this.trigger('bid.updated', this.grid.gridView.get('dataSource').data);
    } else {
      // input bid value is not valid
      _.extend(selectedItem, {
        bidStatus: bidStatus.Error,
        bidHintKey: validateResult.bidHintKey,
      });

      this.refreshGrid(this.grid.gridView.get('dataSource').data);
    }
  }

  updateBudget(budget, isAllBidValid) {
    this.budget = budget;

    if (this.checkLimitaion() && isAllBidValid) {
      // fetch data when bid is valid and keyword count is within limitation
      if (_.isArray(this.adGroups) && !_.isEmpty(this.adGroups)) {
        this.fetchEstimate();
      }
    }
  }

  updateAdGroups(adGroup, data) {
    if (!_.isArray(adGroup)) {
      adGroup = [adGroup]; //eslint-disable-line
    }

    const adGroups = _.map(this.grid.gridView.get('dataSource').data, (item) => {
      const targetAdgroup = _.chain(adGroup).where({ Id: item.Id }).first().value();

      if (!_.isUndefined(targetAdgroup)) {
        return _.isEmpty(data) ? targetAdgroup : _.extend(targetAdgroup, this.calcTraffic(data, targetAdgroup), this.statusUpdate(targetAdgroup));
      }

      return item;
    }, this);

    this.refreshGrid(adGroups);
  }

  fetchEstimate(adGroup = this.adGroups, bid = null, spinner = this.$('.grid')) {
    this.resetMesages();

    if (!_.isArray(adGroup)) {
      adGroup = [adGroup]; //eslint-disable-line
    }

    getTrafficEstimation({
      locations: jsdata.Intermediate.getAll('CampaignCriterion'),
      adGroup,
      bid,
      budget: decimal.fromFloatToString(this.budget),
      languages: this.languages,
      campaignType: this.campaignType,
    }, {
      onNotAllSupported: (supportedCount, totalCount) => {
        this.viewModel.infoMessage(i18n.get('TarfficEstimation_PartiallyNonSupported')
          .replace('{0}', supportedCount)
          .replace('{1}', totalCount));
        this.viewModel.hasUnsupportedLocations(true);
      },
      onSuccess: (data) => {
        this.updateAdGroups(adGroup, data);
      },
      onRequestError: () => {
        this.viewModel.errorMessage(i18n.get('Budget_TrafficEstimation_RequestError'));

        _.each(adGroup, (item) => {
          _.extend(item, {
            bidStatus: bidStatus.Error,
            bidHintKey: bidHintKey.Other,
          });
        });

        this.updateAdGroups(adGroup);
      },
      onNonSupported: () => {
        // todo [yucongj] hint for no locations supported
      },
      onServiceNotSupported: (message) => {
        this.viewModel.errorMessage(message);
      },
    }, {
      spinner,
    }, undefined, (op) => {
      const isDSAMixedModeCampaignEnabled = _.result(config.get('Permissions'), 'IsDSAMixedModeCampaignEnabled', false);

      if (isDSAMixedModeCampaignEnabled) {
        const campaignTrafficEstimate = _.chain(op)
          .result('data')
          .result('CampaignTrafficEstimate')
          .value();

        // For mixed mode campaign, there may be dynamic ad groups created which don't have any keyword in it
        // we need to filter out these ad groups or trafficEstimate API will return error
        if (campaignTrafficEstimate && campaignTrafficEstimate.AdGroupTrafficEstimateParameters) {
          campaignTrafficEstimate.AdGroupTrafficEstimateParameters = _.filter(campaignTrafficEstimate.AdGroupTrafficEstimateParameters, (param) => {
            return param.KeywordTrafficEstimateParameters && param.KeywordTrafficEstimateParameters.length > 0;
          });
        }
      }

      return op;
    });
  }

  calcTraffic(response, adgroup) {
    try {
      const adGroupResult = _
        .chain(response.value)
        .where({
          AdGroupName: adgroup.Name,
        })
        .first()
        .result('AdGroupEstimatedTraffic')
        .pick('Clicks', 'Impressions', 'TotalCost', 'AveragePosition')
        .value();

      if (
        adgroup.Bid < adgroup.suggestedBid &&
        adgroup.Bid > adgroup.suggestedBid / 2 &&
        adgroup.suggestedClicks > adGroupResult.Clicks &&
        adgroup.suggestedImpressions > adGroupResult.Impressions) {
        _.extend(adGroupResult, {
          bidStatus: bidStatus.Warning,
          bidHintKey: bidHintKey.NormalLowBid,
        });

        if (this.activityLogger) {
          this.activityLogger.signal(JSON.stringify({
            Scenario: 'CampaignCreation',
            SuggestedBid: adgroup.suggestedBid,
            InputBid: adgroup.Bid,
            LowBidAlertType: 'Normal',
            EventName: 'CreationFlowLowBidAlertShow',
            SuggestedBidRequestId: adgroup.suggestedBidRequestId,
            CampaignId: this.campaignId,
            AdgroupId: adgroup.Id,
            CurrencyId: this.currencyCode,
          }));
        }
      } else if (
        adgroup.Bid < adgroup.suggestedBid / 2 &&
        adgroup.suggestedClicks > adGroupResult.Clicks &&
        adgroup.suggestedImpressions > adGroupResult.Impressions) {
        _.extend(adGroupResult, {
          bidStatus: bidStatus.Warning,
          bidHintKey: bidHintKey.CriticalLowBid,
        });

        if (this.activityLogger) {
          this.activityLogger.signal(JSON.stringify({
            Scenario: 'CampaignCreation',
            SuggestedBid: adgroup.suggestedBid,
            InputBid: adgroup.Bid,
            LowBidAlertType: 'Critical',
            EventName: 'CreationFlowLowBidAlertShow',
            SuggestedBidRequestId: adgroup.suggestedBidRequestId,
            CampaignId: this.campaignId,
            AdgroupId: adgroup.Id,
            CurrencyId: this.currencyCode,
          }));
        }
      } else {
        adGroupResult.bidStatus = bidStatus.Good;
      }
      return adGroupResult;
    } catch (e) {
      throw new Error('Exception happens when parsing the traffic estimations');
    }
  }

  statusUpdate(adgroup) {
    if (this.suggestionEnabled) {
      return {
        bidStatus:
          adgroup.suggestedBid > decimal.fromLocalToFloat(adgroup.Bid) ?
            bidStatus.Warning : bidStatus.Good,
      };
    } else {
      return {};
    }
  }

  toggleBidHint(e) {
    const hintKey = e.target.dataset.hintKey;
    // const forCriticalLowBid = hintKey === bidHintKey.CriticalLowBid || hintKey === bidHintKey.NormalLowBid;
    let contentText = i18n.get(hintKey || bidHintKey.Other);

    if (hintKey === bidHintKey.BidExceedRange) {
      contentText = contentText.replace('{0}', bidRange.FloorValue)
        .replace('{1}', bidRange.CeilingValue);
    }

    const selectedItem = this.grid.gridView.itemOfElement(e.target);

    const suggestionBid = selectedItem.suggestedBid;
    const click = weekly2MonthlyInt(selectedItem.suggestedClicks - selectedItem.Clicks);
    const impressionsMore = weekly2MonthlyInt(selectedItem.suggestedImpressions - selectedItem.Impressions);
    const lowBidBtnTitle = this.options.newI18n.getString(_TL_('Recommended ad group bid'));
    const lowBidBtnContent = this.options.newI18n.getString(_TL_('You could get {{impressionsMore}} more impressions and {{click}} more clicks if you adjust the bid to {{suggestionBid}}.'),
      {
        suggestionBid,
        impressionsMore,
        click,
      }
    );
    const applyBtnText = this.options.newI18n.getString(_TL_('Apply'));

    if (this.activityLogger) {
      this.activityLogger.signal(JSON.stringify([{
        Scenario: 'CampaignCreation',
        SuggestedBid: suggestionBid,
        InputBid: selectedItem.Bid,
        EventName: 'CreationFlowLowBidAlertClick',
        SuggestedBidRequestId: selectedItem.suggestedBidRequestId,
        CampaignId: this.campaignId,
        AdgroupId: selectedItem.Id,
        CurrencyId: this.currencyCode,
      }]));
    }

    const content = bidToolTipLowBid({
      appendLearnMoreLink,
      i18n,
      contentText,
      hintKey,
      bidHintKey,
      lowBidBtnTitle,
      lowBidBtnContent,
      applyBtnText,
    });

    $(e.target).popover({
      html: true,
      trigger: 'manual',
      content,
      placement: 'right',
    });

    popoverExtender.decorate($(e.target),
      this.excludeCb,
      _.bind(this.clickCb, this),
      _.bind(this.closeCb, this, null));

    $(e.target).popover('toggle');

    $('.close-button').click(() => {
      $(e.target).popover('destroy');
      $(this).closest('.popover').remove();
    });

    $('.cancel-link').click(() => {
      $(e.target).popover('destroy');
      $(this).closest('.popover').remove();
    });

    $('.apply-link').click(() => {
      if (this.activityLogger) {
        this.activityLogger.signal(JSON.stringify([{
          Scenario: 'CampaignCreation',
          SuggestedBid: suggestionBid,
          OriginalInputBid: selectedItem.Bid,
          EventName: 'CreationFlowLowBidSuggestionApply',
          SuggestedBidRequestId: selectedItem.suggestedBidRequestId,
          CampaignId: this.campaignId,
          AdgroupId: selectedItem.Id,
          CurrencyId: this.currencyCode,
        }]));
      }
      this.bidUpdated(e, decimal.fromFloatToString(suggestionBid));
      $(e.target).popover('destroy');
      $(this).closest('.popover').remove();
    });
  }

  raiseBidPopup(e) {
    const target = $(e.target);
    const popup = target.children('.raise-bid-popup-container');
    const content = popup.children('.raise-bid-popup-content');
    const visibleContent = popup.children('.raise-bid-popup-content:visible');
    const suggestedBid = popup.data('suggested_bid');
    const selectedItem = this.grid.gridView.itemOfElement(e.target);
    const suggestedClicks = weekly2MonthlyInt(selectedItem.suggestedClicks - selectedItem.Clicks);
    const impressionsMore = weekly2MonthlyInt(selectedItem.suggestedImpressions - selectedItem.Impressions);

    if (popup.length > 0 && visibleContent.length === 0) {
      $('.raise-bid-popup-container').hide();
      if (content.length === 0) {
        if (selectedItem.bidHintKey === 'TrafficEstimation_Hint_NormalLowBid') {
          const view = new PopupContentView({
            i18n,
            suggestedBid,
            bidHintKey: selectedItem.bidHintKey,
            suggestedClicks,
            impressionsMore,
            el: popup,
            newI18n: this.options.newI18n,
            callback: () => this.bidUpdated(e, decimal.fromFloatToString(suggestedBid)),
          });

          view.render();
        } else {
          const view = new PopupContentView({
            i18n,
            suggestedBid,
            bidHintKey: selectedItem.bidHintKey,
            el: popup,
            newI18n: this.options.newI18n,
            callback: () => this.bidUpdated(e, decimal.fromFloatToString(suggestedBid)),
          });

          view.render();
        }

      }
      logBidView(_.defaults(
        selectedItem,
        { campaignId: this.campaignId }
      ), this.activity);
      selectedItem.viewedSuggestion = true;
      popup.show();
    }
  }

  excludeCb($container, e) {
    const $target = $(e.target);

    return Boolean($target.closest('.popover').length > 0 || $target.closest('.bid-hint-text').length > 0);
  }

  clickCb() {
    $('.icon-info').popover('destroy');
    // $('.dismiss-link').closest('.popover').remove();
    $('.cancel-link').closest('.popover').remove();
  }

  closeCb() {
    _.noop();
  }

  enough() {
    return _.every(_.map(this.grid.gridView.get('dataSource').data, (adGroup) => {
      return adGroup.Bid >= adGroup.suggestedBid;
    }));
  }
}
